var path = 'src/app/ui/fatal-error/fatal-error.html';
var html = "<div class=overlay ng-show=notification ng-click=close()> <div class=overlay-inner> <div class=fatal-error ng-click=$event.stopPropagation()> <div class=fatal-error-inner> <div class=fatal-error-heading>{{notification.title}}</div> <div class=fatal-error-body>{{notification.message}}</div> <div class=fatal-error-footer> <button class=\"btn btn-default\" type=button ng-click=close()>Close</button> <button class=\"btn btn-primary\" type=button ng-click=reload()>Reload</button> </div> </div> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/ui/fatal-error/fatal-error.html
 ** module id = 662
 ** module chunks = 0
 **/